module.exports = __webpack_public_path__ + "static/media/tablet-android-alt.26a5e708.svg";